// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6y-0";
export var startPickingButton = "_6y-1";